<template>
  <div>
    <span v-html="activityMessage"></span>
  </div>
</template>

<script>
export default {
  name: 'TableCreated',
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    activityMessage() {
      const actor = this.activity?.actorUser?.name || 'Bilinmeyen Kullanıcı';
      const tableName = this.activity?.payload?.tableName || 'İsimsiz Tablo';
      
      return this.$t('notification.tableCreated', {
        actor: `<strong>${actor}</strong>`,
        tableName: `<strong>${tableName}</strong>`
      });
    }
  }
};
</script>

<style scoped>
</style>

